export function getEstadoConductorMessage(usuario) {
  if (!usuario) return null;
  
  const cargosPermitidos = ['CONDUCTOR', 'TI'];
  if (!cargosPermitidos.includes(usuario.cargo)) return null;

  const { estado_conductor, detalle_estado } = usuario;

  switch (estado_conductor) {
    case 'NO_APTO':
      return {
        severity: 'error',
        sticky: true,
        closable: false,
        summary: 'Estado: No apto para conducir.',
        detail:
          detalle_estado ||
          'El conductor no cumple las condiciones mínimas para una conducción segura.'
      };

    case 'ALERTA_MEDIA':
      return {
        severity: 'warn',
        sticky: true,
        closable: false,
        summary: 'Estado: Proceda con Precaución.',
        detail:
          detalle_estado ||
          'Se recomienda evaluar las condiciones antes de iniciar la conducción.'
      };

    case 'APTO':
      return {
        severity: 'success',
        sticky: true,
        closable: false,
        summary: 'Estado: Apto para conducir.',
        detail: detalle_estado || 'El conductor cumple con las condiciones para conducir de forma segura.'
      };

    default:
      return null;
  }
}
